module.exports = __webpack_public_path__ + "img/acc1.fb1979f5.png";